import React from 'react';
import { Divider, Typography } from '@mui/material';
import rosun from '../../../../../images/Agri-info/crops/Garlic-sprouts_রসুন.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const RosunInfo = () => {

    // dynamic title
    useDocumentTitle("রসুন");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                রসুন
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={rosun} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">পুষ্টিমূল্যঃ </p>
                            <p className="card-text">রসুনে আমিষ, প্রচুর ক্যালসিয়াম ও সামান্য ভিটামিন ‘সি’ থাকে।</p>

                            {/* <p className="card-text fw-bold">উপযুক্ত জমি ও মাটিঃ</p> */}
                            <p className="card-text"><b>ভেষজ গুণঃ</b> <br />
                                ১)         কৃমি নাশক<br />
                                ২)         শ্বাস কষ্ট কমায়<br />
                                ৩)         হজমে সহায়তা করে<br />
                                ৪)         প্রস্রাবের বেগ বাড়ায়<br />
                                ৫)         শ্বাসনালীর মিউকাস বের করে দেয়<br />
                                ৬)         এ্যাজমা রোগীর উপশম দেয়</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>                                ৭)         হাইপারটেনশন কমায়<br />
                    ৮)         চুল পাকানো কমায়<br />
                    ৯)         শরীরে কোলেস্টেরল লেভেল কমায়।</p>

                <p className="card-text fw-bold">ব্যবহারঃ </p>
                <p className="card-text">মসলা হিসেবে রসুন ব্যবহৃত হয়। তাছাড়া বিভিন্ন আচার ও মুখরোচক খাবার তৈরিতে রসুনের ব্যবহার রয়েছে।</p>

                <p className="card-text fw-bold">উপযুক্ত জমি ও মাটিঃ </p>
                <p className="card-text">জৈব পদার্থ সমৃদ্ধ ও সহজেই গুড়া হয় এমন মাটি রসুনের উপযোগী।</p>
                <p><b>জাত পরিচিতিঃ </b>অনুমোদিত জাত নেই। স্থানীয় জাত চাষ করা হয়।</p>

                <p className="card-text fw-bold">চারা তৈরিঃ</p>
                <p className="card-text fw-bold">বীজ বপনঃ </p>
                <p className="card-text">শুকনো রসুনের বাহিরের সারির কোয়া লাগানো হয়। ১৫ সে.মি. দূরত্বে সারি করে ১০ সে.মি. দূরে ৩-৪ সে.মি. গভীরে রসুনের কোয়া লাগানো হয়। প্রতি হেক্টরে ৩০০-৩৫০ কেজি বীজ রসুনের প্রয়োজন হয়।</p>

                <p className="card-text fw-bold">সার ব্যবস্থাপনাঃ </p>
                <p className="card-text">রসুনে হেক্টর প্রতি সারের পরিমাণ হলো-গোবর ১০ টন, ইউরিয়া ২০০ কেজি, টিএসপি ১২৫ কেজি, এমওপি ১০০ কেজি, জিংক সালফেট ২০ কেজি, বোরাক্স ১০ কেজি ও জিপসাম ১০০ কেজি। জমি তৈরির সময় সমুদয় গোবর, টিএসপি, জিংক সালফেট, বোরাক্স ও জিপসাম মাটির সাথে মিশিয়ে দিতে হবে। রসুন লাগানোর ৩০ দিন ও ৬০ দিন পর যথাক্রমে ১ম ও ২য় কিস্তির উপরি সার প্রয়োগ করা হয়। প্রতিবারে প্রতি হেক্টরে ১০০ কেজি ইউরিয়া ও ৫০ কেজি এমওপি সার প্রয়োগ করা হয়।</p>

                <p className="card-text fw-bold">সেচ ও আগাছা ব্যবস্থাপনাঃ </p>
                <p className="card-text">মাটিতে রসের অভার থাকলে মাঝে মাঝে সেচ দিতে হবে। প্রতিবার সেচ দেয়ার পর মাটি নিড়ানি দিয়ে কুপিয়ে ঝুরঝুরে করে দিতে হবে। আগাছা দেখা দিলে তা পরিষ্কার করতে হবে।</p>

                <p className="card-text fw-bold">পোকা</p>
                <p className="card-text fw-bold">পোকার নাম : থ্রিপস</p>
                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">থ্রিপস ছোট আকারের পোকা বলে সহজে নজরে আসে না কিন্তু' পাতার রস চুষে খায় বলে অধিক আক্রমণে পাতা শুকিয়ে গাছ মরে যায় ও ফলন কম হয়।</p>

                <p className="card-text fw-bold">পোকা চেনার উপায় : </p>
                <p className="card-text">স্ত্রী পোকা সরম্ন,  হলুদাভ। পুরম্নষ গাঢ় বাদামী । বাচ্চা পোকা হলুদ অথবা সাদা । এদের পিঠের উপর লম্বা দাগ দেখা যায়।  </p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">রস চুষে খায় বলে পাতা রূপালী রং ধারণ করে অথবা ক্ষুদ্রাকৃতির বাদামী দাগ বা ফোটা দেখা যায়। আক্রমণ বেশী হলে পাতা শুকিয়ে মরে যায়। কন্দ আকারে ছোট ও বিকৃত হয়।  </p>
                <p><b>অনুকুল পরিবেশ :</b> বিকল্প পোষকের উপস্তিতি।</p>

                <p className="card-text fw-bold">জীবন চক্র :</p>
                <p className="card-text">স্ত্রী পোকা পাতার কোষের মধ্যে ৪৫-৫০ টি ডিম পাড়ে। ৫-১০ দিনে ডিম হতে নিম্ফ (বাচ্চা) বের হয়। নিম্ফ ১৫-৩০ দিনে দুটি ধাপ অতিক্রম করে । প্রথম ধাপে খাদ্য গ্রহণ করে  এবং দ্বিতীয় ধাপে খাদ্য গ্রহণ না করে মাটিতে থাকে । এরা বছরে ৮ বার বংশ বিস্তার করে এবং স্ত্রী পোকা পুরুষ পোকার সাথে মিলন ছাড়াই বাচ্চা দিতে সক্ষম ।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা : </p>
                <p className="card-text">সাদা রংয়ের আঠালো ফাঁদ ব্যবহার ক্ষেতে মাকড়সার সংখ্যা বৃদ্ধি করে এ পোকা দমন করা যায়। অনুমোদিত কীটনাশক নির্ধারিত মাত্রায় প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">রোগ ব্যবস্থাপনা</p>
                <p><b>রোগের নাম : </b>পার্পল বস্নচ / বস্নাইট</p>
                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">এ রোগ পেঁয়াজের সবচেয়ে বেশি ক্ষতি করে। যে কোন বয়সে গাছের পাতা ও কান্ড আক্রান্ত হয়। অধিক আক্রমনে পেঁয়াজে ফুল আসে না ও ফসল কম হয়। আক্রান্ত বীজ বেশিদিন গুদামে রাখা যায়না । বাজার মূল্য কমে যায়।</p>

                <p className="card-text fw-bold">রোগের কারণ : </p>
                <p className="card-text">অল্টারনারিয়া পোরি ও স্টেমফাইলিয়াম বট্রাইওসাম নামক ছত্রাকদ্বয় দ্বারা এ রোগ হয়ে থাকে।</p>
                <p>- আক্রান্ত পাতা ক্রমান্বয়ে উপরের দিক হতে মরতে শুরু করে।<br />
                    - পাতা বা কান্ডের গোড়ায় আক্রান্ত স্থানের দাগ বৃদ্ধি পেয়ে হঠাৎ পাতা বা বীজবাহী  কান্ড ভেঙ্গে পড়ে এতে বীজ অপুষ্ট হয় ও ফলন কম হয়।</p>
                <p><b>অনুকুল পরিবেশ : </b>বৃষ্টিপাত হলে এ রোগ দ্রত  বিস্তার লাভ করে।</p>
                <p><b>বিস্তার : </b>আক্রান্ত বীজ, গাছের পরিত্যাক্ত অংশ ও বায়ুর মাধ্যমে এ রোগ বিস্তার লাভ করে।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা :</p>
                <p className="card-text">
                    - রোগ প্রতিরোধী বা সহনশীল জাত ব্যবহার<br />
                    - রোগমুক্ত বীজ ব্যবহার<br />
                    - ফসল পর্যায় অনুসরন করা অর্থ্যাৎ একই জমিতে পর পর কমপক্ষে ৪ বছর পেঁয়াজ না করা<br />
                    - পেঁয়াজ গাছের পরিত্যাক্ত অংশ, আগাছা ধ্বংশ করা<br />
                    - অনুমোদিত ছত্রাক নাশক নির্ধারিত মাত্রায় প্রয়োগ করা ।</p>

                <p className="card-text fw-bold">কান্ড  পঁচা রোগ</p>
                <p><b>রোগের নাম : </b>কান্ড পঁচা</p>
                <p><b>রোগের কারণ : </b>স্ক্লেরোসিয়াম রলফসি ও ফিউজারিয়াম নামক ছত্রাক দ্ধারা এ রোগ হয়।</p>
                <p className="card-text fw-bold">ভূমিকা :  </p>
                <p className="card-text">যে কোন বয়সে গাছ এ রোগে আক্রান্ত হতে পারে। কন্দ ও শিকড়ে এর আক্রমণ দেখা যায়। আক্রান্ত কন্দে পচন ধরে এবং আক্রান্ত  কন্দ গুদামজাত করে বেশী দিন রাখা যায় না।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">- আক্রান্ত গাছের পাতা হলদে হয়ে যায় ও ঢলে পড়ে ।<br />
                    - টান দিলে আক্রান্ত গাছ খুব সহজে মাটি থেকে কন্দসহ ( পেঁয়াজ) উঠে আসে।<br />
                    - আক্রানত স্থানে সাদা সাদা ছত্রাক এবং বাদামী বর্ণের গোলাকার ছত্রাক গুটিকা (স্ক্লেরোসিয়াম ) দেখা যায়।</p>

                <p className="card-text fw-bold">অনুকুল পরিবেশ : </p>
                <p className="card-text">অধিক তাপ ও আর্দ্রতা পূর্ণ মাটিতে এ রোগ দ্রত বিস্তার লাভ করে। ক্ষেতে সেচ দিলেও এ রোগ বৃদ্ধি পায়।</p>

                <p className="card-text fw-bold">বিস্তার : </p>
                <p className="card-text">এ  রোগের জীবাণু মাটিতে বসবাস করে বিধায় সেচের পানির মাধ্যমে ও মাটিতে আন্তঃ পরিচর্যার সময় কাজের হাতিয়ারের মাধ্যমে এ রোগের বিস্তার হয়।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা :</p>
                <p className="card-text">
                    - আক্রান্ত গাছ তুলে ধ্বংশ করতে হবে।<br />
                    - মাটি সব সময় স্যাঁত স্যাঁতে রাখা যাবে না।<br />
                    - আক্রান্ত জমিতে প্রতি বছর পেঁয়াজ /রসুন চাষ করা যাবে না।<br />
                    - অনুমোদিত ছত্রাক নাশক নির্ধারিত মাত্রায় প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">ফসল সংগ্রহঃ   </p>
                <p className="card-text">রসুন গাছের পাতা শুকিয়ে বাদামী রং ধারণ করলে ঢলে পড়ে তখন রসুন তোলার উপযোগী হয়। গাছসহ রসুন তোলা হয় এবং ঐ ভাবে ছায়াতে ভালভাবে শুকিয়ে মরা পাতা কেটে সংরক্ষণ করা হয়। প্রতি হেক্টরে ১০-১২ টন ফলন পাওয়া যায়।</p>


            </div>
        </div >


    );
};

export default RosunInfo;